module.exports = __webpack_public_path__ + "img/ai5@2x.50abcabe.png";